import { render, staticRenderFns } from "./the-type-of-audit-item.vue?vue&type=template&id=90f9d27a"
import script from "./the-type-of-audit-item.vue?vue&type=script&lang=js"
export * from "./the-type-of-audit-item.vue?vue&type=script&lang=js"
import style0 from "./the-type-of-audit-item.vue?vue&type=style&index=0&id=90f9d27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports